require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-kirthiga-reddypartone.json") })
        }
      }, "path---insights-kirthiga-reddypartone");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-kirthiga-reddypartone!./.cache/json/insights-kirthiga-reddypartone.json
// module id = 1112
// module chunks = 231608221292675